import {useState,useRef} from 'react'
import './addObjet.css'
import {animated,useSpring} from 'react-spring'
function AddObjet({}){
    const [objetAdding,setObjetAdding] = useState();
    const idArduino = useRef()
    const springs = useSpring({
        from: { 
            opacity :0 },
        to: { 
            opacity :1 },
      })
    const handeleAddObjet = () =>{

    }
    return <animated.div style={{...springs}} className="bg-addObjet">
        <h3>Ajouter un Objet</h3>
        {/* <div className="categorie"> */}
        <div className="formControl">
            <label htmlFor="idArduino"> L'Id de votre Arduino</label>
            <input type="text" name="idArduino" ref={idArduino} id="idArduino" placeholder='Id Arduino'/>
        </div>
        <div className="formControl">
            <label htmlFor="tokenId">L'Id Jetton</label>
            <input type="text" name="tokenId" id="tokenId" placeholder='Jeton Id'/>            
        </div>
        <div className="formControl">
            <label htmlFor="categorie">Fonction Objet</label>
            <select name="categorie" id="categorie" placeholder='Fonction Objet'>
                <option value="commande">Commande</option>
                <option value="controle">Contrôle</option>
                <option value="autre">Autres...</option>
            </select>
        </div>
        <div className="formControl">
            <label htmlFor="nameObjet">Nom de l'opjet</label>
            <input type="text" name="nameObjet" id="nameObjet" placeholder='Nom Objet'/>
        </div>
        <div className="formControl">
            <label htmlFor="objet">L'objet</label>
            <select name="objet" id="objet" placeholder='Objet'>
                <option value="lampe">Lampe</option>
                <option value="splite">Splite</option>
                <option value="porte">Porte</option>
                <option value="congelateur">Congelateur</option>
                <option value="television">Television</option>
                <option value="autres">Autres...</option>
            </select>
            
        </div>
        <div className="formControl">
            <label htmlFor="passwordConfirm">Mot de passe</label>
            <input type="password" name="passwordConfirm" id="passwordConfirm" placeholder='Votre mot de passe pour Ajouter' />
        </div>
            <button type="button">Ajouter</button>
        {/* </div> */}
        
    </animated.div>
}

export default AddObjet